import useHandleMOCError from '@/composables/use-handle-moc-error';
import {errorToastOptions} from '@/util-toast';

import {getAllRegionProvinces} from '@/api/province/province.api';
import {getAllServiceAreaHighways} from '@/api/service-area/service-area.api';
import {
  selectionModeEnum,
  filtersTypeEnum,
  advancedSearchComponentEnum,
  formItemTypeEnum,
  matchModeEnum,
  operatorEnum,
} from '@sttedra_ui/framework';

const {wrapApiMOCError} = useHandleMOCError();
const filterName = (() => {
  return {
    field: 'name',
    label: 'Nombre',
    type: formItemTypeEnum.INPUTTEXT,
    value: '',
    matchMode: matchModeEnum.CONTAINS,
    operator: operatorEnum.AND,
    hidden: true,
  };
});

const filterTown = (() => {
  return {
    field: 'town',
    label: 'Población',
    type: formItemTypeEnum.INPUTTEXT,
    value: '',
    matchMode: matchModeEnum.CONTAINS,
    operator: operatorEnum.AND,
    hidden: true,
  };
});
const defaultPropertiesDropDown = {
  options: [],
  optionLabel: 'name',
  optionValue: 'name',
};
const filterHighway = (() => {
  return {
    field: 'highway',
    label: 'Autopista',
    type: formItemTypeEnum.DROPDOWN,
    value: null,
    matchMode: matchModeEnum.EQUALS,
    operator: operatorEnum.AND,
    properties: {
      options: [],
      optionLabel: 'highway',
      optionValue: 'highway',
    },
    hidden: true,
    events: {
      onMounted: async (updateModel) => {
        const errorHighways = errorToastOptions('Error', 'Error al cargar las autopistas');
        const {data: highways} = await wrapApiMOCError(getAllServiceAreaHighways, errorHighways)();
        updateModel((item) => {
          item.properties.options = highways;
          return item;
        });
      },
    },
  };
});
const filterProvince = (() => {
  return {
    field: 'province',
    label: 'Provincia',
    type: formItemTypeEnum.DROPDOWN,
    value: null,
    matchMode: matchModeEnum.CONTAINS,
    operator: operatorEnum.AND,
    properties: defaultPropertiesDropDown,
    hidden: true,
    events: {
      onMounted: async (updateModel) => {
        const errorProvinces = errorToastOptions('Error', 'Error al cargar las provincias');
        const {provinces} = await wrapApiMOCError(getAllRegionProvinces, errorProvinces)();
        updateModel((item) => {
          item.properties.options = provinces;
          return item;
        });
      },
    },
  };
});
const filterRegion = (() => {
  return {
    field: 'region',
    label: 'Comunidad Autónoma',
    type: formItemTypeEnum.DROPDOWN,
    value: null,
    matchMode: matchModeEnum.CONTAINS,
    operator: operatorEnum.AND,
    properties: defaultPropertiesDropDown,
    hidden: true,
    events: {
      onMounted: async (updateModel) => {
        const errorRegions = errorToastOptions('Error', 'Error al cargar las CAs');
        const {regions} = await wrapApiMOCError(getAllRegionProvinces, errorRegions)();
        updateModel((item) => {
          item.properties.options = regions;
          return item;
        });
      },
    },
  };
});
const filterCategory = (() => {
  return {
    field: 'categoria',
    label: 'Categorías',
    type: formItemTypeEnum.DROPDOWN,
    matchMode: matchModeEnum.MULTIPLE_EQUALS,
    operator: operatorEnum.AND,
    properties: {
      options: [],
      optionLabel: 'label',
      optionValue: 'field',
    },
    hidden: true,
  };
});
function defaultFilters(
  nameField = 'name',
  regionField = 'region',
  provinceField = 'province',
  townField = 'town',
  highwayField = 'highway',
  categoryField = 'categoria',
) {
  return [
    filterName(nameField),
    filterRegion(regionField),
    filterProvince(provinceField),
    filterTown(townField),
    filterHighway(highwayField),
    filterCategory(categoryField),
  ];
}
function copyText(data, copy, recordToText) {
  const text = recordToText(data);
  copy(text);
}
export default class QueryTableConfig {
  constructor({
    title = '',
    api: apiRaw,
    recordToText,
    copyClipboard,
    htmlQuery = null,
    printQuery = null,
    htmlRecord = null,
    printRecord = null,
    centerMap,
    downloadPDF = null,
    openLink = null,
    viewStops = null,
    schema,
    fieldName = 'name',
    fieldProvince = 'province',
    fieldRegion = 'region',
    fieldCategory = 'categoria',
    filterFields = [],
  }) {
    return {
      title,
      api: (args) => wrapApiMOCError(apiRaw)(args),
      schema,
      actions: {
        header: [
          {
            label: 'Imprimir HTML',
            icon: 'print',
            extended: false,
            hidden: !htmlQuery,
            command: () => wrapApiMOCError(htmlQuery)(),
          },
          // {
          //   label: 'Imprimir',
          //   icon: 'print',
          //   extended: false,
          //   hidden: !printQuery,
          //   command: () => wrapApiMOCError(printQuery)(),
          // },
        ],
        item: [
          {
            label: 'Mostrar paradas',
            icon: 'airline_stops',
            extended: false,
            hidden: !viewStops,
            command: (e) => wrapApiMOCError(viewStops)(e.data),
          },
          {
            label: 'Ver en PDF',
            icon: 'picture_as_pdf',
            extended: false,
            hidden: !downloadPDF,
            command: (e) => wrapApiMOCError(downloadPDF)(e.data),
          },
          {
            label: 'Ver página web',
            icon: 'open_in_new',
            extended: false,
            hidden: !openLink,
            command: (e) => wrapApiMOCError(openLink)(e.data),
          },
          {
            label: 'Centrar en el mapa',
            icon: 'pin_drop',
            extended: false,
            disabled: (data) => !data.coordinates || !data.coordinates.length,
            command: (e) => centerMap(e.data),
          },
          {
            label: 'Copiar texto completo',
            icon: 'content_copy',
            extended: false,
            disabled: () => !copyClipboard || !recordToText,
            command: (e) => copyText(e.data, copyClipboard, recordToText),
          },
          {
            label: 'Imprimir',
            icon: 'print',
            extended: false,
            hidden: !printRecord,
            command: (e) => wrapApiMOCError(printRecord)(e.data),
          },
          {
            label: 'Exportar HTML',
            icon: 'html',
            extended: false,
            hidden: !htmlRecord,
            command: (e) => wrapApiMOCError(htmlRecord)(e.data),
          },
        ],
      },
      filters: [
        {
          type: filtersTypeEnum.ADVANCED,
          component: advancedSearchComponentEnum.PANEL,
          // eslint-disable-next-line max-len
          fields: defaultFilters(fieldName, fieldRegion, fieldProvince, fieldCategory).concat(filterFields),
        },
      ],
      views: [
        {
          type: 'table',
          selectionMode: selectionModeEnum.UNSET,
          shownActions: 6,
        },
        {
          type: 'list',
          selectionMode: selectionModeEnum.UNSET,
          shownActions: 6,
        },
      ],
      behaviour: {
        useQuery: false,
      },
    };
  }
}
